import React, { useEffect } from 'react';
// import Head from 'next/head';

import { useTheme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import FullRow from './ui/blocks/FullRow';
import LineBreak from './ui/blocks/LineBreak';

import network from '../assets/images/index/network.gif';
import hardware from '../assets/images/index/hardware.gif';
import learn from '../assets/images/index/learn.gif';

export default function Services(props) {
    const theme = useTheme();
    const matchesSM = useMediaQuery(theme.breakpoints.down("sm"));
    const content = props.content.services;
    const language = props.language;

    const setValue = props.setValue;
    useEffect(() => {
        window.scrollTo(0, 0);
        setValue(1);
    }, [setValue]);

    return (
        <React.Fragment>
            {/* <Head>
                <title key="title">شبکه عصر دانش آرا</title>
                <meta name="description" key="description" content="شرکت شبکه عصر دانش آرا، ارائه دهنده خدمات اکتیو و پسیو شبکه و کامپیوتر" />
                <meta property="og:title" key="og:title" content="شرکت شبکه عصر دانش آرا، ارائه دهنده خدمات اکتیو و پسیو شبکه و کامپیوتر" />
            </Head> */}

            <Grid container direction="column" dir={language === "per" ? "rtl" : null}>
                <Grid item style={{
                    marginLeft: matchesSM ? 0 : language === "per" ? "0em" : "5em",
                    marginRight: matchesSM ? 0 : language === "per" ? "5em" : "0em",
                    marginTop: matchesSM ? "1em" : "2em"
                }}>
                    <Typography align={matchesSM ? "center" : undefined} variant="h2" gutterBottom >{content.title}</Typography>
                </Grid>

                <FullRow content={content.services[1]} image={network} imageW={"450px"} language={language} dir={0} />
                <LineBreak height="75px" type={0} />
                <FullRow content={content.services[2]} image={hardware} imageW={"450px"} language={language} dir={1} />
                <LineBreak height="75px" type={1} />
                <FullRow content={content.services[3]} image={learn} imageW={"450px"} language={language} dir={0} />

            </Grid>
        </React.Fragment>
    )
}